// Library methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { ACCENT_TEAL } from "../ChoiceCard/ChoiceCard";

// Utils
import { EXAM_TYPE_LABELS, sortExamTypes } from "src/utils/emr/examTypeHelper";

// Types
import { EMRExamType } from "src/services/emr/types";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type ExamTypePickerType = {
  options: Array<EMRExamType>;
  value: Array<EMRExamType>;
  onChange: (examTypes: Array<EMRExamType>) => void;
};

const ExamTypePicker = ({ options, value, onChange }: ExamTypePickerType) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);
  const isDark = theme.palette.mode === "dark";

  const toggle = (examType: EMRExamType) =>
    onChange(
      value.includes(examType)
        ? value.filter((item) => item !== examType)
        : sortExamTypes([...value, examType])
    );

  return (
    <Box display="flex" flexWrap="wrap" gap="6px">
      {sortExamTypes(options).map((examType) => (
        <Box
          component="label"
          key={examType}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            minHeight: "36px",
            padding: "0px 10px 0px 6px",
            borderRadius: "6px",
            cursor: "pointer",
            border: `1px solid ${isDark ? "#8A8DA2" : "rgba(0, 0, 0, 0.2)"}`,
            backgroundColor: isDark ? "#1C1D29" : "transparent",
          }}
        >
          <Checkbox
            checked={value.includes(examType)}
            onChange={() => toggle(examType)}
            sx={{
              padding: "2px",
              color: onSurface,
              "&.Mui-checked": { color: ACCENT_TEAL },
            }}
          />
          <Typography fontSize="13px" fontWeight={700} color={onSurface}>
            {t(EXAM_TYPE_LABELS[examType])}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ExamTypePicker;
